// ##### 24-07-22 Komarov
import { SET_OTHERS_NAME } from "../constants";
// ##### 25-03-26 Komarov
export const setOthersName = (name) => (dispatch) => {
  dispatch({
    type: SET_OTHERS_NAME,
    payload: name,
  });
};
